import { CatchAnimBase } from "./AnimBase";
import { Goalie, GoalieCatchAnim } from "./Goalie";



export class Anim1 extends CatchAnimBase {
    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(ballPos: pc.Vec2, ballTime: number, data: GoalieCatchAnim): void {
        this._flags = 0;

        // Cas spusteni animace
        this._animStartTime = ballTime - data.animTimeOffset;

        // Horizontalni posun pres "side step" animaci
        let goaliePos = this._goalie.entity.getPosition();
        let hDis = ballPos.x - goaliePos.x;
        let noMoveZoneX = goaliePos.x + data.noHMoveZone.originX * (hDis < 0 ? -1 : 1);

        if (ballPos.x < noMoveZoneX - data.noHMoveZone.halfWidth || ballPos.x > noMoveZoneX + data.noHMoveZone.halfWidth) {
            // Posun brankare pres "side step" animaci
            this._goalie.moveToSide(hDis - (data.noHMoveZone.originX * (hDis < 0 ? -1 : 1)), this._animStartTime)
        }

        // Jmeno animace
        this._animName = data.animName + (hDis > 0 ? "L" : "R");
    }
}